import { Controller, Payload } from "../../config/controller";
import { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { initialValueStatusAppState, StatusAppActions, StatusAppState } from "./root.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { auth, AuthResult } from "../../services/auth";

import { AtendimentoActions, AtendimentoState } from "../atendimento/atendimento.model";
import { PacienteActions, PacienteState } from "../paciente/paciente.model";


export interface StatusAppViewProps {
    statusAppState: StatusAppState
    statusAppActions: StatusAppActions
    atendimentoState: AtendimentoState
    pacienteState: PacienteState  
}


class StatusAppController extends Controller<any, StatusAppState, StatusAppActions> {
    constructor() {
        super("statusapp", initialValueStatusAppState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            START_APP: `@${this.moduloName}/START_APP`
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            startApp: () => action(this.actionsType.START_APP)
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.START_APP, this.startAppEffects.bind(this))
        ]
    }

    private * startAppEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Inicializando o sistema...", error: false },
                this.actionsType.startAppEffects
            ))
            //connectar ao banco de dados 
            let resp: AuthResult = yield call(auth.singInFast);
            console.log("resposta singInFast", resp);
            if (resp.status === "ok") {
                //carregar os medicos
                //yield put(medicoController.reducer.actions.read());
                //carregar salas
                //yield put(salaController.reducer.actions.read()); 

                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Sistema inicializado com sucesso!", error: false, start: true },
                    this.actionsType.startAppEffects
                ))

                //fazer uma busca nos usuarios interno do sistema, para ficar disponivel no login local
                //exempo no sistema dentalminder
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Falha na inicialização do sistema, detalhes: " + resp.mensagem, status: "error", error: true, showAlert: true },
                    this.actionsType.startAppEffects
                ))
            }
        } catch (error: any) {
            console.log("error startAppEffects", error);
            let msg = "Ops, ocorreu uma falha em startAppEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.startAppEffects
            ))
        }
    }

}

export const statusAppController = new StatusAppController()

export const mapStateToStatusAppProps = (state: ApplicationState) => ({
    statusAppState: state.statusAppState,
    atendimentoState: state.atendimentoState,
    pacienteState: state.pacienteState
})

export const mapDispatchToStatusAppProps = (dispatch: Dispatch) => ({
    statusAppActions: bindActionCreators({ ...statusAppController.reducer.actions }, dispatch),
})